import { useState, useEffect, forwardRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Typography,
  TextField,
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Select,
  Stack,
  Pagination,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import Autocomplete from '@mui/material/Autocomplete';

import styledComponent from "styled-components";

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import { Rowing } from '@material-ui/icons';
import jwtDecode from 'jwt-decode';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import imgNotFound from '../../assets/icons/no-image.png'

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '68vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Container = styledComponent.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
      return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const ReadyStockCheckingOut = () => {
    const [token, setToken] = useState(
        JSON.parse(localStorage.getItem('token')) !== null ? 
            JSON.parse(localStorage.getItem('token')).token :
            null
    );

    const [subdistricts, setSubdistricts] = useState([]);
    const [valueSubdistrict, setValueSubdistrict] = useState(subdistricts[0]);
    const handleSelectSubdistrict = (e, val) => {
        setValueSubdistrict(val);
    };
    

    const [cities, setCities] = useState([]);
    const [valueCity, setValueCity] = useState(cities[0]);
    const handleSelectCity = async (e, val) => {
        setValueCity(val);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${val.city_id}`);
            setSubdistricts(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [provinces, setProvinces] = useState([]);
    const [valueProvince, setValueProvince] = useState(provinces[0]);
    const [inputProvValue, setInputProvValue] = useState('');
    const handleSelectProvince = async (e, val) => {
        setValueProvince(val);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${val.province_id}`);
            setCities(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [telPengirim, setTelPengirim] = useState(null);
    const [telPenerima, setTelPenerima] = useState(null);
    const changeTelpPengirim = (value) =>  {
        setTelPengirim(value);
    };
    const changeTelpPenerima = (value) =>  {
        setTelPenerima(value);
    };

    useEffect(() => {
        const refreshToken = async () => {
          try {
              const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/token`, {
                  headers: {
                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  }
              });
              if (response.data.token) {
                  setToken(response.data.token);
                  localStorage.setItem('token', JSON.stringify(response.data));
                  await getProvinces();
              }
              
          } catch (error) {
              console.log(error);
          }
        };
        const getProvinces = async () => {
          try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/province`);
            setProvinces(getData.data.result);
          } catch (err) {
            console.log(err);
          }
        }
    
        if(!verifyToken(token)){
          localStorage.removeItem('token');
          navigate('/');
        }
        refreshToken();
      }, [])

    return (
        <Container>
            <Formik
                initialValues={{ nama: null, whatsapp: null, targetkota: null, program: null }}
                validate={values => {
                    console.log(values);
                    const errors = {};
                    return errors;
                }}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/adsmitra`, values, {
                            headers: {
                                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                            }
                        });
                        // update states
                        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/adsmitra`, {
                            headers: {
                                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                            }
                        });
                        let number = 0;
                        setAdsData(res.data.result.map((v) => {
                            number+=1;
                            return { ...v, no: number };
                        }));
                        setAlertStatus('success');
                        setAlertMessage('Tambah adsense berhasil');
                        setOpenAlert(true);
                        handleClose();
                    } catch (err) {
                        console.log(err);
                        setSubmitting(false);
                    }
                }}
            >
                {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
                }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Nama Pengirim
                            </InputLabel>
                            <TextField
                                fullWidth
                                required
                                type="text"
                                size="small"
                                name="nama_pengirim"
                                id="outlined-basic"
                                variant="outlined"
                                // defaultValue={0}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Telepon Pengirim
                            </InputLabel>
                            <PhoneInput
                                disableDropdown
                                countryCodeEditable={false}
                                name="tel_pengirim"
                                country={'id'}
                                onlyCountries={['id']}
                                value={telPengirim}
                                inputStyle={{ width: '100%', height: '3em' }}
                                onChange={changeTelpPengirim}
                            />

                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Nama Penerima
                            </InputLabel>
                            <TextField
                                fullWidth
                                required
                                type="text"
                                size="small"
                                name="nama_penerima"
                                id="outlined-basic"
                                variant="outlined"
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Telepon Penerima
                            </InputLabel>
                            <PhoneInput
                                disableDropdown
                                countryCodeEditable={false}
                                name="tel_penerima"
                                country={'id'}
                                onlyCountries={['id']}
                                value={telPengirim}
                                inputStyle={{ width: '100%', height: '3em' }}
                                onChange={changeTelpPenerima}
                            />

                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Alamat
                            </InputLabel>
                            <TextField
                                fullWidth
                                required
                                name="alamat"
                                id="outlined-multiline-static"
                                multiline
                                rows={4}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Kode Pos
                            </InputLabel>
                            <TextField
                                fullWidth
                                required
                                type="number"
                                size="small"
                                name="kode_pos"
                                id="outlined-basic"
                                variant="outlined"
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Provinsi Tujuan
                            </InputLabel>
                            <Autocomplete
                                fullWidth
                                size="small"
                                value={valueProvince}
                                onChange={handleSelectProvince}
                                options={provinces}
                                getOptionLabel={(option) => option.province_name}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        {option.province_name}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>                            
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Kota/Kabupaten Tujuan
                            </InputLabel>
                            <Autocomplete
                                fullWidth
                                disabled={cities.length === 0}
                                size="small"
                                value={valueCity}
                                onChange={handleSelectCity}
                                options={cities}
                                getOptionLabel={(option) => option.city_name}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        {option.city_name}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Kecamatan Tujuan
                            </InputLabel>
                            <Autocomplete
                                fullWidth
                                disabled={subdistricts.length === 0}
                                size="small"
                                value={valueSubdistrict}
                                onChange={handleSelectSubdistrict}
                                options={subdistricts}
                                getOptionLabel={(option) => option.subdistrict_name}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        {option.subdistrict_name}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Berat (gram)
                            </InputLabel>
                            <TextField
                                disabled
                                fullWidth
                                required
                                type="number"
                                size="small"
                                name="berat"
                                id="outlined-basic"
                                variant="outlined"
                                value="250"
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Kurir
                            </InputLabel>
                        </Grid>
                    </Grid>
                </form>
                )}
            </Formik>
        </Container>
    )
}

export default ReadyStockCheckingOut
